export enum TirePosition {
    FRONT_LEFT= "FRONT_LEFT",
    FRONT_RIGHT= "FRONT_RIGHT",
    REAR_LEFT= "REAR_LEFT",
    REAR_RIGHT= "REAR_RIGHT",
}
